<template>
  <!-- 竞品渠道模式及变化 -->
  <div class="table_container">
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-style="{ borderColor: '#dcdfe6' }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 品牌 -->
      <el-table-column
        prop="brand"
        label="品牌"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'brand' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.brand"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.brand }}
          </div>
        </template>
      </el-table-column>
      <!-- 直营网点和二级网点合计 -->
      <el-table-column
        label="直营网点和二级网点合计"
        align="center"
        class-name="total_column"
      >
        <!-- 网点数量 -->
        <el-table-column
          label="网点数量"
          min-width="90px"
          align="center"
          class-name="total_column"
        >
          <template slot-scope="scope">
            <div>
              {{ getTotal(scope.row, "outletsNumber") }}
            </div>
          </template>
        </el-table-column>
        <!-- 品牌专营店数量 -->
        <el-table-column
          label="品牌专营店数量"
          min-width="90px"
          align="center"
          class-name="total_column"
        >
          <template slot-scope="scope">
            <div>
              {{ getTotal(scope.row, "brandFranchiseNumber") }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 直营网点 -->
      <el-table-column label="直营网点" align="center">
        <!-- 网点数量 -->
        <el-table-column
          prop="directOutletsNumber"
          label="网点数量"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                editField === 'directOutletsNumber' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.directOutletsNumber"
              class="number_input"
              :controls="false"
              :precision="0"
              :min="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.directOutletsNumber }}
            </span>
          </template>
        </el-table-column>
        <!-- 品牌专营店数量 -->
        <el-table-column
          prop="brandFranchiseNumber"
          label="品牌专营店数量"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                editField === 'brandFranchiseNumber' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.brandFranchiseNumber"
              class="number_input"
              :controls="false"
              :precision="0"
              :min="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.brandFranchiseNumber }}
            </span>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 二级网点 -->
      <el-table-column label="二级网点" align="center">
        <!-- 网点数量 -->
        <el-table-column
          prop="secondOutletsNumber"
          label="网点数量"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                editField === 'secondOutletsNumber' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.secondOutletsNumber"
              class="number_input"
              :controls="false"
              :precision="0"
              :min="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.secondOutletsNumber }}
            </span>
          </template>
        </el-table-column>
        <!-- 品牌专营店数量 -->
        <el-table-column
          prop="secondBrandFranchiseNumber"
          label="品牌专营店数量"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                editField === 'secondBrandFranchiseNumber' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.secondBrandFranchiseNumber"
              class="number_input"
              :controls="false"
              :precision="0"
              :min="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.secondBrandFranchiseNumber }}
            </span>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 售后服务站数量 -->
      <el-table-column
        prop="afterSaleServiceNumber"
        label="售后服务站数量"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input-number
            v-if="
              editField === 'afterSaleServiceNumber' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.afterSaleServiceNumber"
            class="number_input"
            :controls="false"
            :precision="0"
            :min="0"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          >
          </el-input-number>
          <span v-else>
            {{ scope.row.afterSaleServiceNumber }}
          </span>
        </template>
      </el-table-column>
      <!-- 渠道模式变化描述 -->
      <el-table-column
        prop="channelChangeDescription"
        label="渠道模式变化描述"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'channelChangeDescription' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.channelChangeDescription"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.channelChangeDescription }}
          </div>
        </template>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column
        prop="channelRemark"
        label="备注"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'channelRemark' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.channelRemark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.channelRemark }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateCompetitorApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      tableData: [],
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.tableData = data || [];
      this.queryParams = { ...queryParams };
    },
    // 合计
    getTotal(data, type) {
      if (type === "outletsNumber") {
        return (
          (data.directOutletsNumber ? data.directOutletsNumber : 0) +
          (data.secondOutletsNumber ? data.secondOutletsNumber : 0)
        );
      }
      if (type === "brandFranchiseNumber") {
        return (
          (data.brandFranchiseNumber ? data.brandFranchiseNumber : 0) +
          (data.secondBrandFranchiseNumber
            ? data.secondBrandFranchiseNumber
            : 0)
        );
      }
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          dataList: this.tableData
        };
        const res = await addOrUpdateCompetitorApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data;
          this.$emit("updateChannelCompetitor", res.data);
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
